import dayjs from "dayjs";
import { ICustomField } from "../@types/customField.type";
import { mapFieldTypeOptionsValue } from "./mapFieldTypeOptions";

export const validateCustomFields = (field: ICustomField, value: string) => {
  let error = "";

  if (
    field.required &&
    !value &&
    mapFieldTypeOptionsValue[field.customFieldTypeId] !== "booleano"
  ) {
    error = `${field.name} é obrigatório.`;
  } else if (
    mapFieldTypeOptionsValue[field.customFieldTypeId] === "data" &&
    field.required &&
    value &&
    isNaN(new Date(value).getTime())
  ) {
    error = `${field.name} é obrigatório e precisa ser um valor válido.`;

  }  
  else if (mapFieldTypeOptionsValue[field.customFieldTypeId] === "data" && value) {

    const isValidDate = dayjs(value, "YYYY-MM-DD", true).isValid(); 
    const year = dayjs(value).year();
  
    if (!isValidDate || year < 2000 || year > 2100) {
      error = `${field.name} precisa ser um valor válido.`;
    }
  }
  else if (
    mapFieldTypeOptionsValue[field.customFieldTypeId] === "lista" &&
    field.required &&
    !field.listOptions?.includes(value)
  ) {
    error = `${field.name} deve ser uma das opções disponíveis.`;
  }

  return error;
};
